import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarPaquete } from '../../actions/clientes';

const EliminarPaquete = ({ paquete, reestablecerPaquete }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar paquete */
    const handleProcesar = async () => {
        await setStatusProcesar(true);

        await dispatch(eliminarPaquete({
            id: paquete?._id, 
            id_cliente: paquete?.id_cliente
        }));

        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerPaquete(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(paquete){
            setEliminarModal(true);
        }
    }, [paquete]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar contratación de paquete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la contratación del paquete <b>"{paquete?.paquete?.nombre}"</b>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarPaquete;